var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-root d-flex align-items-center",class:{
        'success-type': _vm.color === 'success',
        'error-type': _vm.color === 'error',
        'error-type-light': _vm.color === 'error-light',
        'thin-outline': _vm.thin === true,
        outline: _vm.outline === true,
    }},[_c('input',_vm._g(_vm._b({ref:"input",staticClass:"base-input",class:[
            {
                'success-bg': _vm.color === 'success',
                'error-bg': _vm.color === 'error',
                'error-type-light': _vm.color === 'error-light',
                'pa-2': _vm.padding === true,
            },
            _vm.inputClass,
        ],domProps:{"value":_vm.value},on:{"input":_vm.handleChange}},'input',_vm.$attrs,false),_vm.listeners)),(_vm.icon)?_c('div',{staticClass:"d-flex align-items-center px-2"},[_c('BaseIcon',{attrs:{"name":_vm.icon}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }